"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import dynamic from "next/dynamic";
import { makeQueryClient } from "./query-client";

/**
 * Devtools di-import DINAMIS & hanya di dev. Di production `process.env.NODE_ENV`
 * diganti konstan "production" saat build → cabang dynamic() jadi dead-code →
 * chunk devtools TIDAK ikut ter-bundle (bundle prod tak terpengaruh — Fase 1).
 */
const Devtools = process.env.NODE_ENV !== "production" ? dynamic(() => import("@tanstack/react-query-devtools").then(m => m.ReactQueryDevtools), {
  ssr: false
}) : () => null;
export default function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [client] = useState(makeQueryClient);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Devtools />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== client) {
    t2 = <QueryClientProvider client={client}>{children}{t1}</QueryClientProvider>;
    $[1] = children;
    $[2] = client;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}